import React, { useEffect } from 'react';
import { FiX, FiBriefcase, FiTrendingUp, FiAward, FiPhone, FiShield } from 'react-icons/fi';

const JoinHandsModal = ({ open, onClose }) => {
  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
      return () => { document.body.style.overflow = ''; };
    }
  }, [open]);

  if (!open) return null;

  return (
    <div
      data-testid="join-hands-modal"
      role="dialog"
      aria-modal="true"
      className="fixed inset-0 z-[100] flex items-center justify-center px-4 py-6 bg-black/70 backdrop-blur-sm animate-fadeIn"
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="relative w-full max-w-2xl bg-white rounded-2xl shadow-2xl overflow-hidden max-h-[92vh] overflow-y-auto"
      >
        {/* Hero band */}
        <div className="relative bg-gradient-to-br from-[#1A1A2E] via-[#2A1F2E] to-[#F57C20] px-6 pt-7 pb-6 text-white overflow-hidden">
          <div className="absolute inset-0 opacity-[0.07] mix-blend-overlay pointer-events-none"
               style={{ backgroundImage: "radial-gradient(circle at 1px 1px, white 1px, transparent 0)", backgroundSize: '16px 16px' }} />
          <button
            data-testid="join-hands-close"
            onClick={onClose}
            className="absolute top-4 right-4 w-9 h-9 rounded-full bg-white/15 hover:bg-white/25 flex items-center justify-center transition-colors"
            aria-label="Close"
          >
            <FiX className="w-5 h-5 text-white" />
          </button>
          <p className="relative text-[#F57C20] text-[11px] font-bold tracking-[0.3em] uppercase mb-2">Join Hands With Us</p>
          <h2 className="relative text-2xl md:text-3xl font-light leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
            Grow with India's finest <span className="text-[#F57C20]">private-pool villa estate</span>
          </h2>
          <p className="relative text-white/80 text-sm mt-3 max-w-lg">
            Royal Garden Villas is inviting <strong>experienced travel &amp; booking agents</strong> to partner with us on a long-term basis — subject to management approval.
          </p>
        </div>

        {/* Body */}
        <div className="px-6 py-6">
          <p className="text-[#374151] text-sm leading-relaxed mb-5">
            If you have prior experience with luxury-stay bookings, corporate offsites, destination weddings, or film shoots &mdash; and you have an active network of guests looking for genuine, premium villa stays near Mumbai &amp; Pune &mdash; we would love to hear from you.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-6">
            {[
              { icon: FiBriefcase, title: 'Trusted Brand', desc: 'A gated luxury compound with 7 villa configurations (3 to 12 BHK) and consistent 4.8★ guest ratings.' },
              { icon: FiTrendingUp, title: 'Recurring Business', desc: 'Family holidays, corporate offsites, pre-wedding functions &amp; shoots — year-round demand.' },
              { icon: FiShield, title: 'Reliable Operations', desc: 'Instant online booking, Razorpay payments, dedicated caretaker, timely invoicing.' },
              { icon: FiAward, title: 'Partner Priority', desc: 'Approved agents get fast-track confirmations, priority date holds &amp; dedicated point of contact.' },
            ].map((f, i) => (
              <div key={i} className="flex items-start gap-3 bg-[#F7F8FA] border border-gray-100 rounded-xl p-4">
                <div className="w-9 h-9 rounded-lg bg-[#F57C20]/10 flex items-center justify-center flex-shrink-0">
                  <f.icon className="w-4 h-4 text-[#F57C20]" />
                </div>
                <div>
                  <p className="text-[#1A1A2E] text-sm font-semibold mb-0.5">{f.title}</p>
                  <p className="text-[#6B7280] text-xs leading-snug">{f.desc}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="bg-[#FFF7EC] border border-[#F57C20]/30 rounded-xl p-5 text-center">
            <p className="text-[#1A1A2E] text-sm font-semibold mb-1">Interested in partnering with us?</p>
            <p className="text-[#6B7280] text-xs mb-4">Final partnership terms &amp; onboarding details are discussed one-on-one, subject to management approval.</p>
            <a
              href="tel:+919820088292"
              data-testid="join-hands-call"
              className="inline-flex items-center gap-2 bg-[#F57C20] hover:bg-[#E06A10] text-white font-semibold px-5 py-2.5 rounded-lg text-sm transition-all"
            >
              <FiPhone className="w-4 h-4" />
              Call +91 98200 88292
            </a>
            <p className="text-[#9CA3AF] text-[10px] mt-3">
              Or WhatsApp us the same number with your name, agency &amp; years of experience.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JoinHandsModal;
